// Attach client-only context (screen, viewport, device pixel ratio, timezone) to
// every lead form right before it submits. These values don't exist server-side.
//
// Implemented as a single document-level capture-phase `submit` listener so it runs
// BEFORE each form component's own submit handler builds `new FormData(form)` — the
// injected hidden inputs are then picked up automatically, with no change to any
// individual form component. Lead forms are identified by a phone field (search /
// filter / save-search forms don't have one), so nothing else is touched. The
// server reads these from $_REQUEST in atpl_capture_lead().
export function initClientMeta() {
  const values = () => ({
    client_screen: window.screen && screen.width && screen.height ? `${screen.width}x${screen.height}` : '',
    client_viewport: `${window.innerWidth || 0}x${window.innerHeight || 0}`,
    client_dpr: String(window.devicePixelRatio || 1),
    client_tz: (() => {
      try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch { return ''; }
    })(),
  });

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.querySelector('input[name="phone"]')) return; // lead forms only
      const vals = values();
      Object.keys(vals).forEach((name) => {
        let input = form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }
        input.value = vals[name];
      });
    },
    true
  );
}
